// extracted by mini-css-extract-plugin
export default {"price":"pointPrice-module__price__Qz0Se","activePrice":"pointPrice-module__activePrice__wPd19","visitedPrice":"pointPrice-module__visitedPrice__ngr1n"};